export type SpecialOfferReceiptType =
  | 'unchecked'
  | 'unchecked-ng'
  | 'unchecked-ok'
  | 'leader-checked'
  | 'leader-ng'
  | 'admin'

export enum DelyNgReason {
  FUZZY_RECEIPT = 'fuzzy_receipt',
  INVALID_CHAIN_STORE = 'invalid_chain_store',
  INVALID_DATE_TIME = 'invalid_date_time',
  INVALID_ITEM = 'invalid_item',
  INVALID_RECEIPT = 'invalid_receipt',
  ILLEGAL_RECEIPT = 'illegal_receipt',
  DUPLICATED_RECEIPT = 'duplicated_receipt',
  OTHER = 'other',
}

export enum SpecialOfferStatus {
  ACTIVE = 'ACTIVE',
  // @todo
}

export interface GetSpecialOfferQuery {
  id: string | null
  name: string | null
  status: SpecialOfferStatus | null
}

export interface ISpecialOffer {
  id: string
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  productName: string
  productNameSecond: string | null
  title: string
  offerInformation: string
  aboutProduct: string
  productSiteUrl: string | null
  companyName: string
  targetAgeText: string | null
  targetPurchasePeriodText: string
  displayEndAt: Date
  displayStartAt: Date
  status: SpecialOfferStatus
  nameAdmin: string
  chainStoreNames: string[]
  itemNames: string[]
  itemNameSeconds: string[]
  canFreeItemName: boolean
  canFreeItemNameSecond: boolean
  canFreeChainStoreName: boolean
  needsLeaderCheck: boolean
  receipts: ISpecialOfferReceipt[]

  // not from db
  total: number
}

export interface GetSpecialOfferReceiptQuery {
  target: string
  id: string | null
  transactionId: string | null
  specialOfferId: string | null
  specialOfferNameAdmin: string | null
  specialOfferTitle: string | null
  importedAtStart: string | null
  importedAtEnd: string | null
  ngReason: DelyNgReason | null
}

export interface ISpecialOfferReceipt {
  id: number
  specialOfferId: string
  specialOffer: ISpecialOffer | null
  userId: number
  transactionId: number
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  importedAt: Date
  imagePrefix: string
  phone: string | null
  chainStoreName: string | null
  storeName: string | null
  itemName: string | null
  itemNameSecond: string | null
  dateTime: Date | null
  sum: number | null
  ngReason: DelyNgReason | null
  otherNgReason: string
  systemOkedAt: Date | null
  linkerOkedAt: Date | null
  leaderOkedAt: Date | null
  systemNgedAt: Date | null
  linkerNgedAt: Date | null
  leaderNgedAt: Date | null
  okedByLinkerId: number | null
  okedByLeaderId: number | null
  ngedByLinkerId: number | null
  ngedByLeaderId: number | null
  duplicatedId: number | null
  closedAt: Date | null
  imageUrl: string | null
}
